import * as Sentry from '@sentry/react';
import React from 'react';
import {
    createBrowserRouter,
    useLocation,
    useNavigationType,
    createRoutesFromChildren,
    matchRoutes,
} from 'react-router-dom';
import {
    SENTRY_DSN,
    SENTRY_ENVIRONMENT,
    SENTRY_RELEASE,
    SENTRY_TRACES_SAMPLE_RATE,
    SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
    SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
} from './env';

export function initSentry(options = {}) {
    const dsn = options.dsn !== undefined ? options.dsn : SENTRY_DSN;

    if (!dsn) {
        return;
    }

    Sentry.init({
        dsn,
        environment: options.environment || SENTRY_ENVIRONMENT,
        release: options.release || SENTRY_RELEASE || undefined,
        integrations: [
            Sentry.reactRouterBrowserTracingIntegration({
                useEffect: React.useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: true,
            }),
            ...(options.integrations || []),
        ],
        tracesSampleRate: options.tracesSampleRate !== undefined ? options.tracesSampleRate : SENTRY_TRACES_SAMPLE_RATE,
        replaysSessionSampleRate: options.replaysSessionSampleRate !== undefined ? options.replaysSessionSampleRate : SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
        replaysOnErrorSampleRate: options.replaysOnErrorSampleRate !== undefined ? options.replaysOnErrorSampleRate : SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
        ...options,
    });
}

// Automatically initialize Sentry when imported
initSentry();

export const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);

export function setSentryUser(user, merchant = null) {
    if (user) {
        Sentry.setUser({
            id: user.id ? String(user.id) : undefined,
            email: user.email,
            username: user.name || user.username,
        });
    } else {
        Sentry.setUser(null);
    }

    if (merchant) {
        Sentry.setTag('merchant_id', merchant.id ? String(merchant.id) : undefined);
        Sentry.setTag('merchant_name', merchant.name);
    } else {
        Sentry.setTag('merchant_id', undefined);
        Sentry.setTag('merchant_name', undefined);
    }
}

export { Sentry };
